import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { DataProvider } from "@/context/DataContext";
import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/site/SmoothScroll";
import Layout from "@/components/site/Layout";
import CookieBanner from "@/components/site/CookieBanner";
import Analytics from "@/components/site/Analytics";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Works from "@/pages/Works";
import Gallery from "@/pages/Gallery";
import Guides from "@/pages/Guides";
import GuideCategory from "@/pages/GuideCategory";
import GuidePost from "@/pages/GuidePost";
import ChiediEsperto from "@/pages/ChiediEsperto";
import Diagnostica from "@/pages/Diagnostica";
import LocalPage from "@/pages/LocalPage";
import BeforeAfter from "@/pages/BeforeAfter";
import Zones from "@/pages/Zones";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/servizi" element={<Services />} />
                <Route path="/chi-siamo" element={<About />} />
                <Route path="/lavori" element={<Works />} />
                <Route path="/galleria" element={<Gallery />} />
                <Route path="/guide" element={<Guides />} />
                <Route path="/guide/categoria/:slug" element={<GuideCategory />} />
                <Route path="/guide/:slug" element={<GuidePost />} />
                <Route path="/chiedi-all-esperto" element={<ChiediEsperto />} />
                <Route path="/diagnostica-giardino" element={<Diagnostica />} />
                <Route path="/giardiniere/:slug" element={<LocalPage />} />
                <Route path="/prima-e-dopo" element={<BeforeAfter />} />
                <Route path="/zone-servite" element={<Zones />} />
                <Route path="/domande-frequenti" element={<Faq />} />
                <Route path="/contatti" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/cookie-policy" element={<CookiePolicy />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          </SmoothScroll>
          <CookieBanner />
          <Analytics />
          <Toaster position="bottom-center" richColors offset={80} />
        </BrowserRouter>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
